import { render, staticRenderFns } from "./InspectTypeSetting.vue?vue&type=template&id=46928fdc&scoped=true"
import script from "./InspectTypeSetting.vue?vue&type=script&lang=js"
export * from "./InspectTypeSetting.vue?vue&type=script&lang=js"
import style0 from "./InspectTypeSetting.vue?vue&type=style&index=0&id=46928fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46928fdc",
  null
  
)

export default component.exports